import { selectStandardProps } from "@/utils/componentUtils";
import { Form, Select } from "antd";
import { FormItemProps } from "antd/lib/form";
import { SelectProps } from "antd/lib/select";
import { useTranslation } from "react-i18next";
import { useEnumeration } from "../../../../common/api/queries";
import type { UUID } from "../../../../typings/global";
import { formatCoverageLimit } from "../../../coveragelimit/utils";
import { EnumerationType } from "../../enums";

interface Props {
  formItemProps: FormItemProps;
  selectProps?: SelectProps<string>;
  institutionId: UUID;
}

export const CoverageLimitSelect = ({ formItemProps, selectProps, institutionId }: Props) => {
  const { t } = useTranslation();

  const coverageLimitEnums = useEnumeration(EnumerationType.COVERAGE_LIMITS);

  const resolveCoverageLimitsByDeactivated = (deactivated: boolean) => {
    return coverageLimitEnums
      .filter((coverageLimit) => coverageLimit.institutionId === institutionId)
      .filter((limit) => limit.deactivated === deactivated);
  };

  const activeCoverageLimits = resolveCoverageLimitsByDeactivated(false);
  const deactivatedCoverageLimits = resolveCoverageLimitsByDeactivated(true);

  return (
    <Form.Item {...formItemProps}>
      <Select
        {...selectStandardProps}
        {...selectProps}
        options={[
          ...(activeCoverageLimits.length > 0
            ? [
                {
                  label: t("coverageLimit.helpers.activated"),
                  options: activeCoverageLimits.map((limit) => ({
                    value: limit.id,
                    label: formatCoverageLimit(limit),
                  })),
                },
              ]
            : []),
          ...(deactivatedCoverageLimits.length > 0
            ? [
                {
                  label: t("coverageLimit.helpers.deactivated"),
                  options: deactivatedCoverageLimits.map((limit) => ({
                    value: limit.id,
                    label: formatCoverageLimit(limit),
                  })),
                },
              ]
            : []),
        ]}
      />
    </Form.Item>
  );
};
